module.exports = __webpack_public_path__ + "static/media/halloweenmini.382e0a03.webp";